<template>
  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 gap-2">
    <ul class="space-y-2">
      <li
        v-for="saleListingAgreementSeller in saleListingAgreement.relationships.saleListingAgreementSellers.data"
        :key="saleListingAgreementSeller.id"
      >
        <!-- prevent row click when clicking customer link -->
        <CustomerLink :customer="saleListingAgreementSeller" class="pl-4" @click.stop />
      </li>
    </ul>
  </td>

  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
    <ul class="space-y-2">
      <li
        v-for="saleListingAgreementProperty in saleListingAgreement.relationships.saleListingAgreementProperties.data"
        :key="saleListingAgreementProperty.id"
      >
        <span class="font-semibold text-gray-700">{{ saleListingAgreementProperty.relationships.property.data.relationships.propertyType.data.attributes.name }}</span> - {{ saleListingAgreementProperty.relationships.property.data.attributes.fullAddress }}
      </li>
    </ul>
  </td>

  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
    {{ saleListingAgreement.attributes.commission }} {{ saleListingAgreement.relationships.commissionType.data?.attributes?.name }}
  </td>

  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
    {{ parseDate(saleListingAgreement.attributes.endAt) }}
  </td>

  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
    <div class="flex justify-end space-x-2 pr-4">
      <!-- prevent row click when clicking action links -->
      <router-link
        class="text-indigo-600 hover:text-indigo-900 transition-transform duration-200 hover:scale-110"
        :to="{ name: 'sale-listing-agreement', params: { id: saleListingAgreement.id } }"
        @click.stop
      >
        <MagnifyingGlassIcon class="size-5" aria-hidden="true" />
      </router-link>

      <router-link
        class="text-indigo-600 hover:text-indigo-900 transition-transform duration-200 hover:scale-110"
        :to="{ name: 'edit-sale-listing-agreement', params: { id: saleListingAgreement.id } }"
        @click.stop
      >
        <PencilSquareIcon class="size-5" aria-hidden="true" />
      </router-link>
    </div>
  </td>
</template>

<script setup>
import CustomerLink from "@/components/customers/CustomerLink.vue";
import { PencilSquareIcon, MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import { useDate } from "@/utils/stores/date";

const { parseDate } = useDate();

const props = defineProps({
  saleListingAgreement: Object,
});

const saleListingAgreement = props.saleListingAgreement;
</script>
